import { motion, useWillChange, isValidMotionProp } from "framer-motion";
import { useNavigate } from "react-router";

import { useEffect } from "react";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Box,
  chakra,
  shouldForwardProp,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import SigninForm from "./signinForm";
import useCheckLogin from "../../hook/useCheckLogin";
import { resetInvalidAuth } from "../../redux/action/member/memberAction";
import { COMMON_WEB_PATH } from "../../constant";
import CommonModal from "../../components/Common/CommonModal";
import ReloadButton from "../../components/LayoutComponents/HeaderComponents/ReloadButton.js";
import LngButton from "../../components/LayoutComponents/HeaderComponents/LngButton";
import MusicToggleButton from "../../components/LayoutComponents/HeaderComponents/MusicToggleButton";
import AnnouncementButton from "../../components/LayoutComponents/HeaderComponents/AnnouncementButton";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const Signin = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const baseBg = useColorModeValue("light.100", "dark.100");

  const dispatch = useDispatch();

  const willChange = useWillChange();

  const { isLogin } = useCheckLogin();

  useEffect(() => {
    dispatch(resetInvalidAuth());

    if (isLogin) {
      navigate("/");
    }
  }, []);

  return (
    <ChakraBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      display="flex"
      flexDirection={`column`}
      justifyContent={`flex-start`}
      alignItems="center"
      zIndex="10000"
      py="10vh"
      px="10px"
      width={{
        base: "100%",
      }}
      height={{
        base: "100%",
      }}
      overflowY={`scroll`}
      position="fixed"
      top={`0px`}
      left={`0px`}
      className={`lg:backdrop-blur-none backdrop-blur-md no-scrollbar`}
    >
      <CommonModal bgNone title={i18n_header("signin")}>
        {/* 隱形XX */}
        <Box
          as={Link}
          to={previousPage}
          position="absolute"
          top="-40px"
          right="0px"
          w="30px"
          h="30px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/modal/close_icon.png')`}
          bgSize="100% 100%"
          bgPos="center"
          cursor="pointer"
        ></Box>
        <Box px="common-x">
          <Box
            width="100%"
            px="common-x"
            py="10px"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            className="no-scrollbar"
          >
            <SigninForm />
          </Box>
        </Box>
        <Box
          position={"absolute"}
          bottom={{ base: "-3em" , sm: '-4em'}}
          left="50%"
          transform="translateX(-50%)"
          display={"flex"}
          gap={"10px"}
        >
          <ReloadButton />
          <LngButton />
          <MusicToggleButton />
          <AnnouncementButton />
        </Box>
      </CommonModal>
    </ChakraBox>
  );
};

export default Signin;
